import React, {Component} from 'react';

class Home extends Component{
    render(){
        return (
            <div>
            <div class="container-fluid">
            <div class="row">
              <div class="col-md-12 pad-left60">
              <div class="header-text-style">Automation meets Innovation</div>
            <div class="header-sub-text-style">What would you like to do?</div>
            <div class="div-common-style pointer"  onclick="javascript:PCT(); return true;">
                        <div>
                            <img src={ "images/designNew.png" } class="img-design-style" onclick="javascript:PCT(); return true;"/>
                        </div>
                        <a href="Nest-Dashboard.aspx">  
                            <div class="img-tag-style">DESIGN TRANSITION</div>
                        </a>
                    </div>
            
            <div class="div-common-style pointer div-outer-style" onclick="javascript:Execution(); return true;">
                                        <div>
                                            <img src={"images/ExecutionNew.png"} class="img-execution-style" onclick="javascript:Execution(); return true;"/>
                                        </div>
                                        <a href="Nest-STDashboard.aspx">
                                            <div class="img-tag-style">EXECUTE TRANSITION</div>
                                        </a>
                                    </div>
                                    <div class="div-common-style pointer div-outer-style" onclick="javascript:Governance(); return true;">
                                        <div>
                                            <img src={"images/GovernanceNew.png"} class="img-governance-style" onclick="javascript:Governance(); return true;"/>
                                        </div>
                                        <a href="Governance.aspx">
                                            <div class="img-tag-style">GOVERN TRANSITION</div>
                                        </a>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
                                    </div>
            
      
        
        )
    }
}
export default Home;